import { GetTaskByIdDocument } from '@exam-management/graphql';
import { QSetReviewSubtaskActionMenu } from '@exam-management/task-management';

import { useQSetReviewSubtask } from '../../providers';

export default function QSetReviewSubtaskPageHeaderMenu() {
  const { subtaskDetails } = useQSetReviewSubtask();

  return (
    <QSetReviewSubtaskActionMenu
      taskId={subtaskDetails.id}
      qSetId={subtaskDetails.qSet.id}
      dueDate={subtaskDetails.dueDate}
      refetchQueries={[
        {
          query: GetTaskByIdDocument,
          variables: {
            getTaskByIdInput: {
              taskId: subtaskDetails.id,
            },
          },
        },
      ]}
    />
  );
}
